export const arrangeRecoveredItems = (cartItems = [], recoveredCartItems = []) => {
    const itemsInBag = new Set(cartItems.map(item => item.simpleSku));
    return recoveredCartItems
        .filter(recoveredItem => !itemsInBag.has(recoveredItem.simpleSku))
        .sort((prev, next) => {
        if (prev.stockStatus > next.stockStatus)
            return 1;
        if (prev.stockStatus < next.stockStatus)
            return -1;
        return 0;
    });
};
//# sourceMappingURL=helpers.js.map